import IconClose from 'assets/icons/close.svg?inline'
import IconEventAvailable from 'assets/icons/event-available.svg?inline'
import IconFileCopy from 'assets/icons/file-copy.svg?inline'
import IconDirectionsCar from 'assets/icons/directions-car.svg?inline'
import IconLanguage from 'assets/icons/language.svg?inline'
import IconLock from 'assets/icons/lock.svg?inline'
import IconHotel from 'assets/icons/hotel.svg?inline'
import IconPinDrop from 'assets/icons/pin-drop.svg?inline'
import IconToday from 'assets/icons/today.svg?inline'
import IconDirectionsRun from 'assets/icons/directions-run.svg?inline'
import IconRobotFilled from 'assets/icons/robot-filled.svg?inline'
import IconLogin from 'assets/icons/login.svg?inline'
import IconLogout from 'assets/icons/logout.svg?inline'
import IconNotifications from 'assets/icons/notifications.svg?inline'
import IconUser from 'assets/icons/user.svg?inline'
import { componentIconType } from 'src/constants/chatMenu'

const menuIconMap = {
  room_reservation: 'icon-hotel',
  car_reservation: 'icon-directions-car',
  restaurant_reservation: 'icon-today',
  room_reservation_confirmation: 'icon-event-available',
  experience_reservation: 'icon-directions-run',
  directions: 'icon-pin-drop',
  custom_bot_requests: 'icon-notifications',
  back: 'icon-robot-filled',
  languages: 'icon-language',
  login_and_signup: 'icon-user'
}

export default {
  components: {
    IconEventAvailable,
    IconDirectionsRun,
    IconFileCopy,
    IconDirectionsCar,
    IconRobotFilled,
    IconLanguage,
    IconLock,
    IconHotel,
    IconLogin,
    IconLogout,
    IconPinDrop,
    IconToday,
    IconNotifications,
    IconUser,
    IconClose
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    termsOfUseLink: {
      type: String,
      required: true
    },
    privacyPolicyLink: {
      type: String,
      required: true
    }
  },

  setup() {
    return {
      menuIconMap,
      componentIconType
    }
  }
}
